<template>
  <div :class="$style.root" @click="handleClick">
    <div :class="$style.head">
      <div :class="$style.time">{{ item.time }}</div>
      <div
        :class="$style.headText1"
        v-if="item.status === $const.PinTaunStatus.PENDING"
        >待成团</div
      >
      <div
        :class="$style.headText1"
        v-else-if="item.status === $const.PinTaunStatus.COMPLETE"
        >已成团</div
      >
      <div
        :class="$style.headText2"
        v-else-if="item.status === $const.PinTaunStatus.EXPIRED"
        >未成团</div
      >
    </div>
    <div :class="$style.body">
      <div class="u-relative">
        <img :class="$style.itemImg" :src="item.goodPreivewImage" />
        <span :class="$style.peopleNeed">{{ item.peopleNeed }}人团</span>
      </div>
      <div :class="$style.itemDetail">
        <div :class="$style.itemDetailRow1" v-html="item.goodName"></div>
        <div :class="$style.itemDetailRow2"> 已团{{ item.doneNum }}件 </div>
        <div :class="$style.itemDetailRow3">
          <span :class="$style.promptPrice"
            ><span :class="$style.priceSymbol">￥</span
            >{{ item.promptPrice }}</span
          ><span :class="$style.price"
            ><span :class="$style.priceSymbol">￥</span>{{ item.price }}</span
          >
          <button
            v-if="item.isSendCoupon"
            @click.stop="handleAction"
            :class="$style.itemViewBtn"
            >点击领取</button
          >
          <button v-else-if="item.status !== this.$const.PinTaunStatus.EXPIRED" @click.stop="handleAction" :class="$style.itemBtn"
            >邀请好友</button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// PinTaunStatus: {
//       PENDING: 1,
//       COMPLETE: 2,
//       EXPIRED: 3,
//     },
export default {
  name: "PinTuanItem1",
  props: {
    item: {},
  },
  methods: {
    handleClick() {
      this.$emit("click", this.item);
    },
    handleAction() {
      this.$emit("action", this.item);
    },
  },
};
</script>

<style lang="scss" module>
$page-width: 375;
@import "~style/tool";

.root {
  padding: rem(10px) rem(12px) rem(15px) rem(15px);
  background-color: #fff;
  // position: relative;
}

.head {
  display: flex;
  align-items: center;
  line-height: 1;
}

.time {
  font-size: rem(11px);
  color: rgba(102, 102, 102, 1);
}

.headText1 {
  font-size: rem(12px);
  color: #e95a59;
  margin-left: auto;
}
.headText2 {
  font-size: rem(12px);
  margin-left: auto;
  color: rgba(153, 153, 153, 1);
}

.body {
  margin-top: rem(9px);
  display: flex;
}

.peopleNeed {
  position: absolute;
  left: 0;
  top: rem(6px);
  font-size: rem(12px);
  color: rgba(255, 255, 255, 1);
  background: rgba(233, 90, 89, 1);
  border-radius: 0px rem(15px) rem(15px) 0px;
  padding: rem(0) rem(6) 0 rem(4px);
  transform: scale(0.9);
  transform-origin: left center;
}

.itemImg {
  flex: 0 0 auto;
  display: block;
  width: rem(104px);
  height: rem(104px);
}

.itemDetail {
  line-height: 1;
  flex: 1 auto;
  margin-left: rem(9px);
  display: flex;
  flex-direction: column;
}

.itemDetailRow1 {
  line-height: 1.3;
  margin-top: rem(8);
  font-size: 14px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
}

.itemDetailRow2 {
  margin-top: rem(4);
  font-size: 11px;
  color: rgba(153, 153, 153, 1);
}

.itemDetailRow3 {
  margin-left: rem(-3px);
  margin-top: auto;
  display: flex;
  align-items: center;
}

.priceSymbol {
  font-size: rem(15px);
}

.promptPrice {
  font-size: rem(21px);
  font-weight: bold;
  color: rgba(233, 90, 89, 1);
}

.price {
  margin-top: rem(4);
  margin-left: rem(3);
  font-size: rem(15px);
  color: rgba(153, 153, 153, 1);
  text-decoration: line-through;
}

.itemBtn {
  margin-left: auto;
  border: 0;
  padding: rem(7px) rem(14px);
  height: rem(30px);
  font-size: rem(12px);
  border: 1px solid rgba(233, 90, 89, 1);
  color: rgba(255, 255, 255, 1);
  background: rgba(233, 90, 89, 1);
  border-radius: 15px;
}

.itemViewBtn {
  composes: itemBtn;
  color: rgba(233, 90, 89, 1);
  background: #fff;
}
</style>
